module.exports = __webpack_public_path__ + "fonts/AudiType-ExtendedItalic_4.03.d36a2421.woff";